var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.handleScroll),expression:"handleScroll"}]},_vm._l((_vm.sorted),function(st,n){return _c('product',{key:st.id,class:['col-sm-3 col.md-4 col-xs-12 col-lg-2 col-6 up','product-'+ n],attrs:{"product":st,"scroll":_vm.scroll}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }